import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import ProfileForm from '../../components/profilemng/ProfileForm';
import dayjs from 'dayjs';
import * as authApi from '../../lib/api/auth';
import { tempSetUser } from '../../modules/auth';

const ProfileFormContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { user } = useSelector(({ auth }) => ({
    user: auth.user,
  }));

  let initialValues = {
    usrNo: user && user.usrNo !== null ? user.usrNo : '',
    usrNm: user && user.usrNm !== null ? user.usrNm : '',
    emlAddr: user && user.emlAddr !== null ? user.emlAddr : '',
    dptUuid: user && user.dptUuid !== null ? user.dptUuid : '',
    gradeUuid:
      user && user.gradeUuid !== null ? user.gradeUuid : '',
    telNo: user && user.telNo !== null ? user.telNo : '',
    postAddrTxt:
      user && user.postAddrTxt !== null ? user.postAddrTxt : '',
    postAddrNm:
      user && user.postAddrNm !== null ? user.postAddrNm : '',
    entryDt: user && user.entryDt !== null ? user.entryDt : '',

    gender: user && user.gender !== null ? user.gender : '',
  };

  const validationSchema = yup.object({
    usrNo:yup.string().required('사번을 입력하세요'),
    usrNm:yup.string().required('이름을 입력하세요'),
    dptUuid:yup.string().required('부서를 선택하세요'),
    gradeUuid:yup.string().required('직급을 선택하세요'),
    emlAddr: yup
      .string('')
      .email('이메일 형식이 아닙니다.')
      .required('이메일을 입력하세요'),
    telNo: yup.string().required('연락처를 입력하세요'),
    postAddrNm: yup.string().required('우편번호를 입력하세요'),
    postAddrTxt: yup.string().required('주소를 입력하세요'),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      let dataToSubmit = {
        usrUuid: user.usrUuid,
        usrNo:values.usrNo.trim(),
        usrNm: values.usrNm.trim(),
        entryDt : dayjs(values.entryDt).format('YYYY-MM-DD'),
        emlAddr: values.emlAddr.trim(),
        gradeUuid: values.gradeUuid,
        gender:values.gender,
        telNo: values.telNo.trim(),
        postAddrNm: values.postAddrNm.trim(),
        postAddrTxt: values.postAddrTxt,
      };

      try {
        const res = await authApi.editUserInfo(dataToSubmit);

        if (res.data) {
          
          dispatch(tempSetUser(res.data));
          localStorage.setItem('user', JSON.stringify(res.data));
          enqueueSnackbar('프로필 정보 수정 성공', {
            variant: 'success',
          });
        }
      } catch (err) {
        let message =
          typeof err.response !== 'undefined'
            ? err.response.data.message
            : err.message;
        enqueueSnackbar(message, {
          variant: 'error',
        });
      }

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <ProfileForm user={user} formik={formik} />;
};

export default ProfileFormContainer;
